import React, { createContext, useState, useContext } from "react";
import AbhaPopup from "../views/Hospital-Admin/Patients/AbhaPopup";
import { mergePatientAbha } from "../api/abhaApi";
import ToastContainer, { useToast } from "../components/common/ToastContainer";
import { useLocation, useNavigate } from "react-router-dom";

const AbhaLinkContext = createContext();

export const useAbhaLink = () => useContext(AbhaLinkContext);

export const AbhaLinkProvider = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const { toasts, removeToast, showSuccess, showError } = useToast();
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [targetPatient, setTargetPatient] = useState(null);

  const [abhaTab, setAbhaTab] = useState("create");
  const [loginType, setLoginType] = useState("mobile");
  const [step, setStep] = useState(1);
  const [aadhar, setAadhar] = useState("");
  const [mobile, setMobile] = useState("");
  const [abhaId, setAbhaId] = useState("");
  const [otp, setOtp] = useState("");
  const [consent, setConsent] = useState(false);

  const isAadharValid = aadhar.replace(/\D/g, "").length === 12;
  const isOtpValid = otp.length === 6;
  const formatAadhar = (val) =>
    val
      .replace(/\D/g, "")
      .replace(/(\d{4})(\d{4})(\d{4})/, "$1 - $2 - $3")
      .slice(0, 14);

  const openAbhaLink = (patient) => {
    setTargetPatient(patient);
    setIsPopupOpen(true);
    setAbhaTab("create");
    setLoginType("mobile");
    setStep(1);
    setAadhar("");
    setMobile("");
    setAbhaId("");
    setOtp("");
    setConsent(false);
  };

  const closeAbhaLink = () => {
    setIsPopupOpen(false);
    setTargetPatient(null);
  };

  const handleTabSwitch = (tab) => {
    setAbhaTab(tab);
    setStep(1);
    setAadhar("");
    setMobile("");
    setAbhaId("");
    setOtp("");
    setConsent(false);
    setLoginType("mobile");
  };

  const handleLoginTypeSwitch = (type) => {
    setLoginType(type);
    setStep(1);
    setAadhar("");
    setMobile("");
    setAbhaId("");
    setOtp("");
    setConsent(false);
  };

  const handleProfileSelected = async (profileData) => {
    if (!targetPatient) return;

    try {
      // payload structure as per user request
      const payload = {
        uhid: targetPatient.uhid,
        id: targetPatient._id || targetPatient.id,
        abhaNumber: profileData.abhaNumber,
        profileDetails: profileData,
      };

      const response = await mergePatientAbha(payload);

      if (location.pathname.startsWith("/OPDDetails")) {
        const data = location.state?.patientData;
        const newid = response.data._id;

        const updatedData = {
          ...data,
          formattedAbhaId: response.data.ABHANumber,
          _id: newid,
          id: newid,
        };

        navigate(`/OPDDetails?patientId=${encodeURIComponent(response.data._id)}`, {
          state: {
            patientData: updatedData,
            patientId: response.data._id,
          },
        });
      }

      window.location.reload();

      console.log("Merge Abha Response:", response);
      if (response && !response.error) {
        showSuccess(response.message || "ABHA Profile Linked Successfully!");
        closeAbhaLink();
      } else {
        showError(response?.message || "Failed to link ABHA profile");
      }
    } catch (error) {
      console.error("ABHA Link Error:", error);
      showError(error.message || "An error occurred while linking ABHA");
    }
  };

  return (
    <AbhaLinkContext.Provider value={{ openAbhaLink }}>
      {children}
      <ToastContainer toasts={toasts} removeToast={removeToast} />
      {isPopupOpen && targetPatient && (
        <div style={{ position: "fixed", zIndex: 9999 }}>
          <AbhaPopup
            abhaTab={abhaTab}
            handleTabSwitch={handleTabSwitch}
            loginType={loginType}
            handleLoginTypeSwitch={handleLoginTypeSwitch}
            step={step}
            setStep={setStep}
            aadhar={aadhar}
            setAadhar={setAadhar}
            mobile={mobile}
            setMobile={setMobile}
            abhaId={abhaId}
            setAbhaId={setAbhaId}
            otp={otp}
            setOtp={setOtp}
            consent={consent}
            setConsent={setConsent}
            isAadharValid={isAadharValid}
            isOtpValid={isOtpValid}
            formatAadhar={formatAadhar}
            handleCloseModal={closeAbhaLink}
            onProfileSelected={handleProfileSelected}
          />
        </div>
      )}
    </AbhaLinkContext.Provider>
  );
};
